(function(ns) {
	"use strict";

	var util = ns.util;

	util.component("confirm-item", {
		props: {
			label: {
				type: String,
				required: true,
			},
		},
		data: function() {
			return {};
		},
	});

})(UE);
